import { OpaqueToken } from '@angular/core';

export let FABRIC8_FORGE_API_URL = new OpaqueToken('fabric8.forge.api.url');

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
